export enum OrderComboTypeEnum {
  SL = 0,
  TP = 1,
  SLTP = 2,
  None = 3
}